<script>
import { email, requiredIf } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import moment from "moment";

// Custom Components
import appConfig from "@/app.config";
import { authMethods, notificationMethods } from "@/state/helpers";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import BookingService from "@/helpers/APIService/booking.service";

// Login component

export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      email: null,
      password: null,
      mobile: null,
      otp: null,
      otpUserId: null,
      isPasswordShow: false,
      submitted: false,
      robot: false,
      isBtnLoading: false,
      loginWitOTP: true,
      isSendOTP: false,
      sendRegOTP: false,
      isEmailOrMobile: true,
      timer: 90,
      isDisableResend: true,
      isSingInOrUp: true,
      isEmailSend: false,
      registerUserId: null,
      emailOTP: null,
      mobileOTP: null,
      newUser: null,
      isRegBtnLoading: false,
      formatedMobile: null,
    };
  },
  validations: {
    email: {
      required: requiredIf(function () {
        if (this.isEmailOrMobile || !this.isSingInOrUp) {
          return true;
        }
      }),
      email,
    },
    password: {
      required: requiredIf(function () {
        if (!this.loginWitOTP) {
          return true;
        }
      }),
    },
    mobile: {
      required: requiredIf(function () {
        if (!this.isEmailOrMobile || !this.isSingInOrUp) {
          return true;
        }
      }),
    },
    otp: {
      required: requiredIf(function () {
        if (this.loginWitOTP && this.isSendOTP) {
          return true;
        }
      }),
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {
    localStorage.clear();
    sessionStorage.clear();
    if (this.loginWitOTP && this.isSendOTP) {
      this.startTimer();
    } else {
      this.timer = 90;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // Method is used to handle change between sing in and sing up
    singInOrUp() {
      this.isSingInOrUp = !this.isSingInOrUp;
      this.loginWitOTP = true;
    },
    // Login With OTP Verification
    loginWithOtp() {
      this.loginWitOTP = !this.loginWitOTP;
      this.isEmailOrMobile = this.loginWitOTP
        ? this.isEmailOrMobile
        : (this.isEmailOrMobile = true);
    },
    // Tru to Register the user in with Email and mobile verification they provided.
    tryToRegister() {
      this.submitted = true;
      this.$v.$touch();
      this.isRegBtnLoading = true;
      if (!this.loginWitOTP && this.$v.$invalid) {
        return;
      } else {
        this.isRegBtnLoading = false;
        if (this.robot == true) {
          this.registerUser();
        } else {
          Middleware.notification("Please verify the captcha !!", "danger");
        }
      }
    },
    // Method is used to handle USER REGISTER API call
    registerUser() {
      try {
        this.isRegBtnLoading = true;
        this.formatedMobile = this.mobile;
        this.mobile = this.removeDecoration(this.mobile);
        UserService.registerUser({
          email: this.email,
          mobile: this.mobile,
        })
          .then((response) => {
            this.isRegBtnLoading = false;
            this.registerUserId = response.id;
            this.otpTimer();
            this.sendRegOTP = true;
            Middleware.notification("Check your email and mobile !!", "info");
          })
          .catch((error) => {
            this.isRegBtnLoading = false;
            this.isEmailSend = false;
            if (error.response.status == 400) {
              if (error.response.data.message == "User already resister") {
                Middleware.notification("User already exists !!", "danger");
              } else if (error.response.data.status == "False")
                return Middleware.notification(
                  "User does not exist or don't have access !!",
                  "danger"
                );
            } else {
              errorHandler(error);
            }
          });
      } catch (error) {
        this.isRegBtnLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to verify user with otp
    registerUserWithEmail() {
      try {
        this.isRegBtnLoading = true;
        if (this.emailOTP == null || this.mobileOTP == null) {
          return Middleware.notification("Please eneter OTP !!", "danger");
        }
        UserService.verifyRegisterUserOTP(this.registerUserId, {
          email_otp_number_verify: this.emailOTP,
          mobile_otp_number_verify: this.mobileOTP,
        })
          .then((response) => {
            if (
              response.is_verify_email_otp_number &&
              response.is_verify_mobile_otp_number
            ) {
              this.isRegBtnLoading = false;
              localStorage.setItem("user", JSON.stringify(response.user_data));
              localStorage.setItem("loggedIn", true);
              this.register(response.user_data);
              Middleware.notification("Registered successfully !!", "success");
              if (response.user_data.user.hotel.length == 0) {
                this.$router.push("/hotel-register");
              } else {
                this.setHotel({
                  hotel_id: response.user_data.user.hotel[0].id,
                });
                this.$router.push("/profile");
              }
            } else {
              this.isRegBtnLoading = false;
              const message =
                !response.is_verify_mobile_otp_number &&
                !response.is_verify_email_otp_number
                  ? "Enter correct Email And Mobile OTP."
                  : !response.is_verify_mobile_otp_number
                  ? "Enter correct Mobile OTP."
                  : !response.is_verify_email_otp_number
                  ? "Enter correct Email OTP."
                  : "Enter Correct OTP.";
              Middleware.notification(message, "danger");
            }
            this.otpTimer();
          })
          .catch((error) => {
            this.isRegBtnLoading = false;
            if (error.response && error.response.status == 400) {
              if (error.response.data.status == "False")
                return Middleware.notification(
                  "User does not exist or don't have access !!",
                  "danger"
                );
              if (error.response.data.mobile_otp_number_verify) {
                Middleware.notification(
                  error.response.data.mobile_otp_number_verify[0],
                  "danger"
                );
              }
              if (error.response.data.email_otp_number_verify) {
                Middleware.notification(
                  error.response.data.email_otp_number_verify[0],
                  "danger"
                );
              }
            }
            errorHandler(error);
          });
      } catch (error) {
        this.isRegBtnLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to reset Email OTP
    resendEmail() {
      if (this.timer == 0) {
        this.registerUser();
        this.timer = 90;
      }
    },
    // OTP timer
    otpTimer() {
      const interValId = setInterval(() => {
        this.timer !== 0 ? (this.timer -= 1) : 0;
        if (this.timer == 0) {
          clearInterval(interValId);
        }
      }, 1000);
    },
    // Try to log the user in with the username and password they provided.
    tryToLogIn(processFor) {
      if (!this.loginWitOTP) {
        this.submitted = true;
        this.$v.$touch();
        if (!this.loginWitOTP && this.$v.$invalid) {
          return;
        } else {
          if (this.email && this.password) {
            if (this.robot == true) {
              this.isBtnLoading = true;
              this.loginUser();
            } else {
              this.isBtnLoading = false;
              Middleware.notification("Please verify the captcha !!", "danger");
            }
          }
        }
      } else {
        this.isBtnLoading = true;
        this.submitted = true;
        this.$v.$touch();
        if (this.loginWitOTP && this.$v.$invalid) {
          this.isBtnLoading = false;
          return;
        } else {
          this.loginUserByOTP(processFor);
        }
      }
    },
    // Method is used to handle USER LOGIN API call
    loginUser() {
      this.login({
        email: this.email,
        password: this.password,
      })
        .then((user) => {
          this.manageUserData(user);
        })
        .catch((error) => {
          this.isBtnLoading = false;
          this.robot = false;
          if (error.response.status == 401) {
            if (error.response.data.detail) {
              this.$refs.recaptcha.reset();
              return Middleware.notification(
                error.response.data.detail,
                "danger"
              );
            }
          }
          Middleware.notification("Please verify the captcha !!", "danger");
          this.$refs.recaptcha.reset();
        });
    },
    // Method is used to login user with OTP
    loginUserByOTP(processFor) {
      if (processFor == "otp") {
        this.loginByOTP({
          otp: this.otp,
          id: this.otpUserId,
          proccesssFor: this.isEmailOrMobile ? "email_otp" : "mobile_otp",
        })
          .then((user) => {
            if (
              user.is_verify_email_otp_number ||
              user.is_verify_mobile_otp_number
            ) {
              this.manageUserData(user.user_data);
            } else {
              this.isBtnLoading = false;
              Middleware.notification(user.verify_failed_message, "danger");
            }
          })
          .catch((error) => {
            Middleware.notification("Please verify the captcha !!", "danger");
            this.isBtnLoading = false;
          });
      } else {
        let data = {};
        if (!this.isEmailOrMobile) {
          this.formatedMobile = this.mobile;
          this.mobile = this.removeDecoration(this.mobile);
          data = { mobile: this.mobile };
        } else {
          data = { email: this.email };
        }
        UserService.sendOTP(data)
          .then((response) => {
            this.otpUserId = response.id;
            this.isSendOTP = true;
            Middleware.notification(
              `Check your ${
                this.isEmailOrMobile ? "email" : "mobile"
              } for OTP !!`,
              "success"
            );
            this.startTimer();
            this.isBtnLoading = false;
          })
          .catch((error) => {
            this.isBtnLoading = false;
            this.submitted = false;
            if (error.response.status == 401) {
              if (error.response.data.detail) {
                Middleware.notification("User does not exist !!", "danger");
              }
            }
            if (error.response.status == 400) {
              if (error.response.data.status == "False") {
                Middleware.notification("User does not exist !!", "danger");
              }
            } else {
              errorHandler(error);
            }
            this.robot = false;
            this.$refs.recaptcha.reset();
          });
      }
    },
    // Method is used to handle user data
    manageUserData(user) {
      localStorage.setItem("loggedIn", true);
      if (user.user.user_type !== "super_admin" && !user.user.is_superuser) {
        if (user.user.user_type == "pbx_admin_staff") {
          this.$router.push("/customer-list");
          return;
        }
        if (user.user.user_hotel == null) {
          this.$router.push("/hotel-register");
        } else {
          this.setHotel(user.user.user_hotel).then((response) => {
            this.isBtnLoading = false;
            if (response.is_pms_connection) {
              this.checkNightAudit();
            }
            Middleware.notification("Successfully logged in !!.", "success");
            this.$router.push("/dashboard");
          });

          if (
            (user.user.user_type = "hotel_staff" && user.user.hotel.length == 0)
          ) {
            this.setRolePermission(user.user.role.id).then((response) => {
              localStorage.setItem("rolePermission", JSON.stringify(response));
            });
          }
        }
      } else {
        this.$router.push("/kiosk-status");
      }
    },
    // Method is used to handle password show/hide
    showHidePassword() {
      this.isPasswordShow = !this.isPasswordShow;
    },
    // Method is used to handle user login type
    changeLoginType(type) {
      this.isEmailOrMobile = type == "email" ? true : false;
    },
    // Method is used to handle E-Mail OTP change
    handleOnEComplete(value) {
      if (String(value).length !== 6) {
        Middleware.notification("Enter 6 digit OTP !!", "danger");
      }
      this.emailOTP = value;
    },
    // Auto submit after input
    handleOnMComplete(value) {
      if (String(value).length !== 6) {
        Middleware.notification("Enter 6 digit OTP !!", "danger");
      }
      this.mobileOTP = value;
    },
    // Method is used to handle OTP complete enter
    handleOnComplete(value) {
      this.otp = value;
      this.tryToLogIn("otp");
    },
    // Method is used to check last night audit date
    async checkNightAudit() {
      const filter = "?ordering=-audit_date&size=1";
      BookingService.getNightAuditList(filter)
        .then((response) => {
          let last_audit = null;
          if (response.results.length !== 0) {
            last_audit = moment(response.results[0].next_audit_date).format(
              "YYYY-MM-DD"
            );
          } else {
            last_audit = moment().format("YYYY-MM-DD");
          }
          localStorage.setItem("last_audit", last_audit);
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to start timer
    startTimer() {
      const interValId = setInterval(() => {
        this.timer !== 0 ? (this.timer -= 1) : 0;
        if (this.timer == 0) {
          clearInterval(interValId);
          this.isDisableResend = false;
        }
      }, 1000);
    },
    // Method is used to resend OTP
    resendOTP() {
      if (!this.isDisableResend) {
        this.loginUserByOTP();
        this.timer = 90;
      }
    },
    resendOTPForReg() {
      if (!this.isDisableResend) {
        this.registerUser();
        this.timer = 90;
      }
    },
    // Method is used to convert number into timer
    convertTime() {
      return moment.utc(this.timer * 1000).format("HH:mm:ss");
    },
    // Method is used to remove extra things from mobile
    removeDecoration(mobile) {
      const mobileStr = mobile.replace(/[^0-9]/g, "");
      return String(mobileStr).replaceAll(" ", "");
    },
    // Vue recaptch related methods
    handleError(error) {
      console.log(error, "Error");
      this.robot = false;
    },
    handleSuccess(response) {
      if (response != null) {
        this.robot = true;
      }
    },
  },
};
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card">
        <div class="bg-soft bg-primary">
          <div class="row">
            <div class="col-7">
              <div class="text-primary p-4">
                <h5 class="text-primary">
                  Welcome {{ isSingInOrUp ? "Back !" : " !" }}
                </h5>
                <p>
                  {{ isSingInOrUp ? "Sign in" : "Sign Up" }} to continue to
                  Macrotech.
                </p>
              </div>
            </div>
            <div class="col-5 align-self-end">
              <img
                src="@/assets/images/profile-img.png"
                alt
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div>
            <div class="avatar-lg profile-user-wid mb-3 ms-2">
              <span class="avatar-title rounded-circle bg-light">
                <h5 class="login-logo-text mb-0">
                  Guest<span class="text-primary">XP</span>
                </h5>
              </span>
            </div>
          </div>
          <div
            v-if="notification.message"
            :class="'alert ' + notification.type"
          >
            {{ notification.message }}
          </div>
          <!-- * Sign In *-->
          <template v-if="isSingInOrUp">
            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group v-show="loginWitOTP">
                <div class="d-flex align-items-center">
                  <b-form-radio
                    class="form-check mb-3 w-50"
                    value=""
                    id="email"
                    name="email"
                    @change="changeLoginType('email')"
                    checked
                    >Email
                  </b-form-radio>
                  <b-form-radio
                    class="form-check mb-3 w-50"
                    value="mobile"
                    id="mobile"
                    name="email"
                    @change="changeLoginType('mobile')"
                    >Mobile Number
                  </b-form-radio>
                </div>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Email"
                label-for="input-1"
                v-if="isEmailOrMobile"
              >
                <b-form-input
                  id="input-1"
                  v-model.trim="email"
                  type="text"
                  autocomplete="off"
                  placeholder="Enter email"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Enter valid email.</span>
                </div>
              </b-form-group>
              <b-form-group
                v-if="loginWitOTP && !isEmailOrMobile"
                class="mb-3"
                id="input-group-1"
                label="Mobile No"
                label-for="input-1"
              >
                <vue-tel-input
                  v-model.trim="mobile"
                  autoFormat
                  input="tel"
                  :autoDefaultCountry="false"
                  :dropdownOptions="{
                    showDialCodeInSelection: true,
                    showFlags: true,
                    width: '390px',
                    showSearchBox: true,
                  }"
                  :preferred-countries="['us', 'gb', 'ua']"
                  :class="{ 'is-invalid': submitted && $v.mobile.$error }"
                ></vue-tel-input>
                <div
                  v-if="submitted && $v.mobile.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.mobile.required">Mobile is required.</span>
                </div>
              </b-form-group>
              <!-- Password and VueRecaptcha -->
              <template v-if="!loginWitOTP">
                <b-form-group
                  class="mb-3"
                  id="password_input"
                  label="Password"
                  label-for="password_input"
                >
                  <div class="position-relative password-icon">
                    <b-form-input
                      id="password_input"
                      v-model.trim="password"
                      :type="isPasswordShow ? 'text' : 'password'"
                      placeholder="Enter password"
                      :class="{ 'is-invalid': submitted && $v.password.$error }"
                    >
                    </b-form-input>
                    <div
                      v-if="submitted && $v.password.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.password.required">
                        Password is required.
                      </span>
                    </div>
                    <template v-if="password !== null && $v.password.required">
                      <i
                        class="fas fa-eye"
                        v-if="isPasswordShow"
                        @click="showHidePassword()"
                      ></i>
                      <i
                        class="fas fa-eye-slash"
                        v-else
                        @click="showHidePassword()"
                      ></i>
                    </template>
                  </div>
                </b-form-group>
                <div class="form-group row">
                  <VueRecaptcha
                    sitekey="6LcNdDMfAAAAAFwkRcoljYjolPpEDInFNIDKraJd"
                    :load-recaptcha-script="true"
                    @verify="handleSuccess"
                    @error="handleError"
                    ref="recaptcha"
                  ></VueRecaptcha>
                </div>
              </template>

              <!-- OTP Number -->
              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="OTP"
                label-for="input-3"
                v-if="loginWitOTP && isSendOTP"
              >
                <v-otp-input
                  class="justify-content-between"
                  ref="input-2"
                  input-classes="otp-input"
                  separator=""
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-complete="handleOnComplete"
                />
              </b-form-group>

              <div class="mt-3 d-grid">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  :disabled="isBtnLoading"
                  ><i
                    v-if="isBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i
                  >{{
                    loginWitOTP && !isSendOTP
                      ? isBtnLoading
                        ? "Sending otp..."
                        : "Send OTP"
                      : "Log In"
                  }}
                </b-button>
              </div>
              <div
                class="d-flex align-items-center justify-content-between"
                v-if="loginWitOTP && isSendOTP"
              >
                <p
                  v-if="timer == 0"
                  class="mb-0 text-decoration-underline text-primary"
                  :class="[timer == 0 ? 'cursor' : '']"
                  @click="resendOTP"
                >
                  Resend OTP
                </p>
                <p class="mb-0" v-if="timer !== 0">
                  Didn't recieve OTP? Try again in
                  <span class="text-primary"> {{ convertTime(timer) }}</span
                  >.
                </p>
              </div>
            </b-form>
          </template>

          <!-- * Sign Up *-->
          <template v-if="!isSingInOrUp">
            <b-form class="p-2">
              <template v-if="!sendRegOTP">
                <b-form-group
                  class="mb-3"
                  id="input-group-1"
                  label="Email"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model.trim="email"
                    type="text"
                    autocomplete="off"
                    placeholder="Enter email"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  ></b-form-input>
                  <div
                    v-if="submitted && $v.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">Email is required.</span>
                    <span v-if="!$v.email.email">Enter valid email.</span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="mb-3"
                  id="input-group-1"
                  label="Mobile No"
                  label-for="input-1"
                >
                  <vue-tel-input
                    v-model.trim="mobile"
                    autoFormat
                    input="tel"
                    :autoDefaultCountry="false"
                    :dropdownOptions="{
                      showDialCodeInSelection: true,
                      showFlags: true,
                      width: '390px',
                      showSearchBox: true,
                    }"
                    :preferred-countries="['us', 'gb', 'ua']"
                    :class="{ 'is-invalid': submitted && $v.mobile.$error }"
                  ></vue-tel-input>
                  <div
                    v-if="submitted && $v.mobile.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.mobile.required">Mobile is required.</span>
                  </div>
                </b-form-group>
                <!-- Password and VueRecaptcha -->
                <div class="form-group row">
                  <VueRecaptcha
                    sitekey="6LcNdDMfAAAAAFwkRcoljYjolPpEDInFNIDKraJd"
                    :load-recaptcha-script="true"
                    @verify="handleSuccess"
                    @error="handleError"
                  ></VueRecaptcha>
                </div>
                <div class="mt-3 d-grid">
                  <b-button
                    type="submit"
                    variant="primary"
                    class="btn-block"
                    :disabled="isRegBtnLoading"
                    @click.prevent="tryToRegister"
                    ><i
                      v-if="isRegBtnLoading"
                      class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    ></i
                    >{{ isRegBtnLoading ? "Sending otp..." : "Send OTP" }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <!-- OTP Number -->
                <b-form-group class="mb-3" id="email_otp" v-if="sendRegOTP">
                  <label for="email_otp" class="fw-medium">
                    Email OTP <span class="text-danger me-1">*</span>
                    <span
                      class="fw-normal cursor"
                      @click="
                        () => {
                          this.sendRegOTP = false;
                        }
                      "
                    >
                      ( {{ email }} )</span
                    >
                  </label>
                  <v-otp-input
                    class="justify-content-between"
                    input-classes="otp-input"
                    separator=""
                    :num-inputs="6"
                    :should-auto-focus="true"
                    :is-input-num="true"
                    @on-complete="handleOnEComplete"
                  />
                </b-form-group>

                <b-form-group
                  class="mb-3"
                  id="mobile_otp"
                  v-if="loginWitOTP && sendRegOTP"
                >
                  <label for="mobile_otp" class="fw-medium">
                    Mobile OTP <span class="text-danger me-1">*</span>
                    <span
                      class="fw-normal cursor"
                      @click="
                        () => {
                          this.sendRegOTP = false;
                        }
                      "
                    >
                      ( {{ formatedMobile }} )</span
                    >
                  </label>

                  <v-otp-input
                    class="justify-content-between"
                    ref="input-4"
                    input-classes="otp-input"
                    separator=""
                    :num-inputs="6"
                    :is-input-num="true"
                    @on-complete="handleOnMComplete"
                  />
                </b-form-group>
                <div class="mt-3 d-grid">
                  <b-button
                    type="submit"
                    variant="primary"
                    class="btn-block"
                    :disabled="isRegBtnLoading"
                    @click.prevent="registerUserWithEmail"
                    ><i
                      v-if="isRegBtnLoading"
                      class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    ></i
                    >{{ "Register" }}
                  </b-button>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between"
                  v-if="loginWitOTP && sendRegOTP"
                >
                  <p
                    v-if="timer == 0"
                    class="mb-0 text-decoration-underline text-primary"
                    :class="[timer == 0 ? 'cursor' : '']"
                    @click="resendOTPForReg"
                  >
                    Resend OTP
                  </p>
                  <p class="mb-0" v-if="timer !== 0">
                    Didn't recieve OTP? Try again in
                    <span class="text-primary"> {{ convertTime(timer) }} </span
                    >.
                  </p>
                </div>
              </template>
            </b-form>
          </template>
          <div
            v-if="isSingInOrUp"
            class="d-flex align-items-center justify-content-center my-3"
          >
            <p class="mb-0 text-center me-2">Sign In With</p>
            <span
              class="card px-2 py-1 mb-0 rounded cursor"
              @click="loginWithOtp"
              >{{ loginWitOTP ? "Email & Password" : "OTP Verification" }}</span
            >
          </div>
        </div>
      </div>

      <p class="text-center mt-5">
        {{
          isSingInOrUp
            ? "Don't have an account yet?"
            : "Already have login and password?"
        }}
        <a @click="singInOrUp" class="text-primary cursor">{{
          isSingInOrUp ? "Register now" : "Sign In"
        }}</a>
      </p>
      <div class="text-center">
        <p>© {{ new Date().getFullYear() }} Macrotech.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.profile-user-wid {
  margin-top: -36px;
}
.login-logo-text {
  font-weight: 700;
  color: black;
}
.password-icon i {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
}
</style>
<style>
.otp-input {
  width: 46px;
  height: 40px;
  padding: 5px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
</style>
